export const USER_ROLES = {
  admin: '0',
  manager: '1',
  viewer: '2',
};